import React, { useState } from 'react';
import { bool, number, string } from 'prop-types';

import { Main } from '@templates';
import { Typography, Flex, Button } from '@mixins';

import ReferFriendImage from '@assets/images/ReferFriend.png';
import { ReferFriendModal } from '@molecules';
import { getCurrency } from '@helpers/common';

const ReferFriend = ({ link, text, title, isLoading, rewardAmount, rewardCurrency }) => {
  const [isModalOpen, setIsModalOpen] = useState(false);

  const handleModalClose = () => {
    setIsModalOpen(false);
  };

  const handleCreateLink = () => {
    setIsModalOpen(true);
  };

  return (
    <Main isLoading={isLoading} isWhiteLabelingOpen={false}>
      <Flex alignItems="start" pt="10px" justifyContent="space-between" width="100%">
        <Flex width="38%" flexDirection="column">
          <Typography mb={30} variant="rightserif-400" fontSize={[26, 30, 34]} lineHeight={0.8}>
            Visit Another Location
          </Typography>
          <Typography maxWidth="80%" mb={30} variant="rightserif-400" fontSize={[12, 16, 20]}>
            It pays to have friends! Your friend gets an office. You get up to{' '}
            {getCurrency(rewardCurrency, rewardAmount)}.
          </Typography>
          <Typography mb={[15, 20, 25, 30]} variant="diatype-400" fontSize={['10px', '13px', '16px']}>
            Know a friend or a company looking for an office? If they join Mindspace we`ll send you cash.
            <br />
            Simple as that. No awkward sales pitch required. Know someone?
          </Typography>
          <Button onClick={handleCreateLink} width={[100, 150, 200]} variant="primary" px="25px" py="12px">
            Create a referral link
          </Button>
        </Flex>
        <Flex
          width="50%"
          height={['140px', '200px', '280px', '340px']}
          background={`url(${ReferFriendImage}) no-repeat right top`}
          backgroundSize="cover"
        />
      </Flex>
      {isModalOpen && (
        <ReferFriendModal link={link} title={title} text={text} isOpen={isModalOpen} onModalClose={handleModalClose} />
      )}
    </Main>
  );
};

ReferFriend.propTypes = {
  rewardAmount: number.isRequired,
  rewardCurrency: string.isRequired,
  link: string.isRequired,
  text: string.isRequired,
  title: string.isRequired,
  isLoading: bool.isRequired,
};

export default ReferFriend;
